import React, { useState, useEffect } from "react";

import { Text } from "./Texts";
import Icon from "./Icon";
import Button from "./Buttons";
import _min from "lodash/min";
import _max from "lodash/max";
import styled from "styled-components";
import colors from "../styles/colors";

const TablePagination = ({ onPageChange, total, size }) => {
  const [current, setCurrent] = useState(1);
  const lastPage = size > total ? total : _min([current + size - 1, total]);

  const goFirst = () => {
    console.log("goFirst action");
    setCurrent(1);
  };

  const goPrevious = () => {
    console.log("goPrevious action");
    setCurrent(_max([1, current - size]));
  };

  const goNext = () => {
    console.log("goNext action");
    setCurrent(_min([total, current + size]));
  };

  const goLast = () => {
    console.log("goLast action");
    setCurrent(total - size + 1);
  };

  useEffect(() => {
    console.log("useEffect", current, lastPage);
    onPageChange(current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  return (
    <StyledPaginationContainer>
      <Text color={colors.subText}>
        {current}-{lastPage} of {total}
      </Text>
      <Button type="link" onClick={goFirst} disabled={current === 1}>
        <Icon size="16px" color={colors.subText} name="icon-page-first"></Icon>
      </Button>
      <Button type="link" onClick={goPrevious} disabled={current === 1}>
        <Icon size="16px" color={colors.subText} name="icon-page-previous"></Icon>
      </Button>
      <Button type="link" onClick={goNext} disabled={lastPage === total}>
        <Icon size="16px" color={colors.subText} name="icon-page-next"></Icon>
      </Button>
      <Button type="link" onClick={goLast} disabled={lastPage === total}>
        <Icon size="16px" color={colors.subText} name="icon-page-last"></Icon>
      </Button>
    </StyledPaginationContainer>
  );
};

export default TablePagination;

const StyledPaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 2px solid #dedede;
  padding: 16px 0 0;

  button {
    margin: 0;
    padding: 8px;
  }
`;
